module.exports = __webpack_public_path__ + "img/resimple_card_lock.76d48ba3.png";